module.exports = __webpack_public_path__ + "img/delete.21352c3a.svg";